const addClassIfSmallScreen = (element, className) => {
  if (window.innerWidth < 768) {
    const el = document.querySelector(element)
    el.classList.add(className)
  }
}

export default addClassIfSmallScreen
